const toast = ( opts ) => {
    let event = new Event( 'onToast' );

    event.data = opts;
    let dispatched = window.dispatchEvent( event );

    return new Promise( (resolve, reject) => dispatched ? resolve() : reject() )
};

export default toast;